export enum NotificationTypeEnum {
  AsignacionDocumentos = 1,
  PrecargaTerceroWeb = 2,
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/enums/NotificationTypeEnum.ts